<highcharts-chart
    [Highcharts]="highcharts"
    [options]="chartOptions"
    [(update)]="updateFlag">
</highcharts-chart>